import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from '../api/api.service';
import { UserStatusInfo } from '../../model/user-status-info.model';
import { lastValueFrom, Observable } from 'rxjs';
import { API_ROUTE_USER, getApiUrl } from '../../app.constants';
import { Router } from '@angular/router';
import { UserData } from '@shared-ikp/model/user-data.model';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';
import { IUserVerificationRequest, IUserVerificationResponse } from '../../model/user-verfication-http.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UserService extends ApiService {
  private popupService = inject(IkpPopupService);
  router = inject(Router);
  userStatusInfo = signal<UserStatusInfo>(null);

  // TODO: API services should be responsible only for communicating with the backend and should only return the httpClient method.
  // The method getUserDataObservable is intended to replace getUserData in future. Maybe in this spike (https://wienenergie.atlassian.net/browse/IKP-2237)

  async getUserData(): Promise<void | UserData> {
    try {
      return await lastValueFrom(this.httpClient.get<UserData>(getApiUrl(this.apiUrl, API_ROUTE_USER)));
    } catch {
      /* ignore errors */
    }
  }

  getUserDataObservable(): Observable<UserData> {
    return this.httpClient.get<UserData>(getApiUrl(this.apiUrl, API_ROUTE_USER));
  }

  getUserStatus(): Observable<UserStatusInfo> {
    return this.httpClient.get<UserStatusInfo>(getApiUrl(this.apiUrl, API_ROUTE_USER + '/status'));
  }

  async getUserStatusInfo(): Promise<void | UserStatusInfo> {
    try {
      const userStatusInfo = await lastValueFrom(this.httpClient.get<UserStatusInfo>(getApiUrl(this.apiUrl, API_ROUTE_USER + '/status')));
      this.userStatusInfo.set(userStatusInfo);
      return userStatusInfo;
    } catch {
      this.handleError();
    }
  }

  verifyUser(requestBody: IUserVerificationRequest): Observable<HttpResponse<IUserVerificationResponse>> {
    return this.httpClient.post<IUserVerificationResponse>(getApiUrl(this.apiUrl, `${API_ROUTE_USER}/verify`), requestBody, {
      observe: 'response',
    });
  }

  registerUser(): Observable<void> {
    return this.httpClient.post<void>(getApiUrl(this.apiUrl, `${API_ROUTE_USER}/register`), {});
  }

  private handleError(): void {
    this.popupService.handleErrorPopup('userstatus-error', 'global.errors.user.title');
  }
}
